import React, { Component } from "react";
import { getI18NMessage } from "./../../../i18n/I18N";

class UserNotRegistered extends Component {
  render() {
    return (
      <div className="notRegisteredDiv">
        <div className="containerDiv">
          <h1 className="firstele">{getI18NMessage("userNotRegistered")}</h1>
          <div className="secondele">
            {getI18NMessage("userNotRegistered2")}
          </div>
        </div>
        <a className="copyright" href="https://www.nimblework.com/">
          NimbleWork Inc &#169; {new Date().getFullYear()}
        </a>
      </div>
    );
  }
}

export default UserNotRegistered;
